export default __webpack_public_path__ + "static/media/dynbanner4-spa.3eca8b71.jpg";